export const getClosestEqualOrBiggerDivisibleNumber = (number: number, divisor: number): number => {
  const quotient = Math.floor(number / divisor);
  const lowerDivisibleNumber = divisor * quotient;

  if (lowerDivisibleNumber === number) {
    return number;
  }
  const upperDivisibleNumber = lowerDivisibleNumber + divisor;

  return upperDivisibleNumber;
};
export const isBetween = (value: number, min: number, max: number): boolean => {
  return value >= min && value <= max;
};
